import { v4 } from 'uuid';
import { ContextMenuItemView, EventContextMenuClickParams } from '@mark43/cad-api';
import { useIntegratedActionBroadcaster } from '../action-broadcaster/use-integrated-action-broadcaster';
import { useOpenEventPanel } from '../event-panel/use-open-event-panel';
import { ContextMenuItem } from '../context-menus/components/context-menu-item';

export function ClearEventItem({
    contextMenuItemView,
    clickParams,
}: {
    contextMenuItemView: ContextMenuItemView;
    clickParams: EventContextMenuClickParams;
}): React.ReactElement {
    const { trigger } = useIntegratedActionBroadcaster();

    const openEventPanel = useOpenEventPanel();

    const handleSelect = (): void => {
        openEventPanel({
            eventId: clickParams.eventId,
        });
        trigger([
            {
                targetWindowType: 'EVENT_V2',
                id: v4(),
                type: 'SHOW_CLEAR_EVENT_MODAL',
                payload: { eventId: clickParams.eventId },
            },
        ]);
    };

    return (
        <ContextMenuItem
            dataTrackId="menu-item-clear-event"
            contextMenuItemView={contextMenuItemView}
            onSelect={handleSelect}
        />
    );
}
